import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Modal, notification, Select, Tooltip, Pagination } from "antd";
import { EditOutlined, SearchOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { vendorService } from "../../../services";
import { checkPermission } from "../../../utils/permissions";
import { changeDocumentTitle } from "../../../utils/title";

function Vendors() {
  const navigate = useNavigate();
  const editVendor = (id) => navigate(`/operations/vendor/form/${id}`);
  const [isModalshow, setIsModalShow] = useState();
  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState(vendors);
  const [loading, setLoading] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (text) => <p>{text ? text : "-"}</p>,
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name"
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space size="small">


          <Tooltip title="Edit">
            {/* <Button
              type="primary"
              size="small"
              onClick={() => editVendor(record.id)}
            > */}

            <EditOutlined onClick={() => editVendor(record.id)} />
            {/* </Button> */}
          </Tooltip>

          <Link to={`/operations/vendor/view/${record.id}`} >
            <Tooltip title="View">
              {/* <Button type="primary" size="small"> */}
              <EyeOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>

          {checkPermission("DELETE_VENDOR") && <Tooltip title="Delete">
            {/* <Button
              type="primary"
              size="small"
              onClick={() => showModalHandler(record)}
            > */}
            <DeleteOutlined onClick={() => showModalHandler(record)} />
            {/* </Button> */}
          </Tooltip>}
        </Space>
      ),
    },
  ];

  const showModalHandler = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleCancel = () => {
    setIsModalShow(false);
  };

  const handleOk = async () => {
    setLoading(true)
    if (!selectedDeleteRecord) return;
    const response = await vendorService.deleteVendor(selectedDeleteRecord.id);
    setLoading(false)
    if (response?.success) {
      setVendors((prevData) =>
        prevData.filter((item) => item.id !== selectedDeleteRecord.id)
      );
      initialize();
      notification.success({
        message: "Success",
        description: "Vendor deleted successfully!",
        placement: "topRight",
      });
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }

    setIsModalShow(false);
  };

  const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
    try {
      setLoading(true);

      const { success, data, message } = await vendorService.fetch(page, pageSize, search);

      if (success) {
        setVendors(data.data);
        setFilteredVendors(data.data);
        setPagination((prev) => ({
          ...prev,
          total: data.total,
          current: page,
          pageSize,
        }));
      } else {
        console.error(`Error fetching vendors: ${message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    changeDocumentTitle("Vendors");
    initialize(pagination.current, pagination.pageSize, search);
  }, [search]);

  return (
    <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">Browse Vendors </h1>
        <Input
          placeholder="Search by Name & Email"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>


      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px", // Adjust padding for smaller size
        }}
        width={300} // Adjust modal width
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }} loading={loading}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>

      <Table
        columns={columns}
        dataSource={filteredVendors}
        loading={loading}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        // }}
        rowKey="id"
        // style={{ marginTop: "10px" }}
        pagination={false}
        style={{ marginTop: "10px" }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default Vendors;
